// @ts-check
import React from 'react';
import { useSelector } from 'react-redux';

import OrgDateFilter from './Search/OrgDateFilter';
import OrgSearchFilterTokens from './Search/OrgSearchFilterTokens';
import {
  getOrganisationResearchersLoading,
  getOrganisationWorkItemIsLoading,
} from 'selectors/organisation';
import { ORGANISATIONPEOPLEVIEW, ORGANISATIONWORKITEMVIEW } from './helpers';

// The rows main search keeps under its "Search Results" heading: the Date window
// and the active filter chips. They describe the results below rather than the
// query above, which is why they sit with the results and not with the search
// bar. Only People and Activity have them — Clinical Trials keeps its own filter
// state, so the shared Date and chips would describe a search it never ran.

/**
 * @param {Object} props
 * @param {{ id: number }} props.organisation
 * @param {string} props.activeTab
 * @param {() => void} props.onPeopleSearch
 * @param {() => void} props.onWorkItemSearch
 * @param {boolean} props.isReset whether Date is still the Last month the Followed Organisations link set
 * @param {() => void} props.onResetConsumed
 */
const OrgResultsHeader = ({
  organisation,
  activeTab,
  onPeopleSearch,
  onWorkItemSearch,
  isReset,
  onResetConsumed,
}) => {
  const researchersLoading = useSelector(
    getOrganisationResearchersLoading(organisation.id)
  );
  const workItemsLoading = useSelector(
    getOrganisationWorkItemIsLoading(organisation.id)
  );

  const isPeople = activeTab === ORGANISATIONPEOPLEVIEW;
  const isWorkItems = activeTab === ORGANISATIONWORKITEMVIEW;

  if (!isPeople && !isWorkItems) return null;

  // Both tabs share Date, so a change on either one retires the Activity notice.
  const handleDateChange = () => {
    onResetConsumed();
    if (isPeople) {
      onPeopleSearch();
    } else {
      onWorkItemSearch();
    }
  };

  return (
    <>
      <OrgDateFilter
        organisationId={organisation.id}
        loading={isPeople ? researchersLoading : workItemsLoading}
        onChange={handleDateChange}
        showResetInfo={isWorkItems ? isReset : undefined}
      />
      <OrgSearchFilterTokens organisationId={organisation.id} />
    </>
  );
};

export default OrgResultsHeader;
